import { checkPageFacebook } from "apis/checkPageFacebook";
import { call, put, takeLatest } from "redux-saga/effects";
import { DEFAULT_ERROR_TEXT } from "utils/constant";
import { showError } from "utils/ToastUtils";
import { checkPageActions } from ".";
import { IResponseCheckLink } from "./type";

export function* checkPageSaga(
  action: ReturnType<typeof checkPageActions.checkingPageStarted>
) {
  try {
    const res: IResponseCheckLink = yield call(
      checkPageFacebook,
      action.payload
    );
    yield put(checkPageActions.checkingPagesSuccess(res));
  } catch (error: any) {
    showError(error?.message || DEFAULT_ERROR_TEXT);
    yield put(checkPageActions.checkingPageFailed(error));
  }
}

export function* watchCheckPageSaga() {
  yield takeLatest(checkPageActions.checkingPageStarted.type, checkPageSaga);
}
